import React, { useState } from 'react';
import CreateProjectModal from './CreateProjectModal'; // путь подкорректируй под свой проект
import s from "../styles/CreateProjectButton.module.css";

const CreateProjectButton = ({ user_id }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button className={s.create_button} onClick={() => setShowModal(true)}>
        ➕ 
      </button>

      {showModal && (
        <CreateProjectModal
        user_id={user_id}
          onClose={() => setShowModal(false)}
          onCreate={(project) => {
            console.log('Проект создан:', project);
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default CreateProjectButton;
